// ===================================================
// sessionUtils.js — 세션 데이터 처리 유틸 함수 모음
//
// sessions 객체 형식:
//   { "YYYY-MM-DD": [{ id, mode, initialText, rounds, keywords, ... }, ...], ... }
//
// 이 형식을 다루는 반복 패턴들을 여기서 중앙 관리합니다.
// ===================================================

// sessions 객체를 평탄화(flatten)해서 날짜 정보가 포함된 배열로 변환
// 반환 형식: [{ date, idx, ...session }, ...]
// 기본적으로 최신 날짜순 정렬
export function flattenSessions(sessions) {
  const result = [];
  Object.entries(sessions).forEach(([date, arr]) => {
    arr.forEach((session, idx) => {
      result.push({ date, idx, ...session });
    });
  });
  return result.sort((a, b) => b.date.localeCompare(a.date));
}

// sessions 객체에서 모든 키워드를 Set으로 수집
// 키워드 추출 시 기존 키워드 중복 방지에 사용
export function collectAllKeywords(sessions) {
  const set = new Set();
  Object.values(sessions).forEach(dayArr =>
    dayArr.forEach(s => (s.keywords || []).forEach(k => set.add(k)))
  );
  return set;
}
